export const SHOW_SIDEBAR = 'SHOW_SIDEBAR'
export const CHANGE_ACTIVED_PAGE = 'CHANGE_ACTIVED_PAGE'
export const SHOW_MESSAGE_BOX = 'SHOW_MESSAGE_BOX'
export const SHOW_LOADING_BOX = 'SHOW_LOADING_BOX'
export const HIDE_LOADING_BOX = 'HIDE_LOADING_BOX'
export const SELECTED_TP_CHANGED = 'SELECTED_TP_CHANGE'

export function showSidebar(show) {
  return {
    type: SHOW_SIDEBAR,
    show,
  }
}

export function activedPageChange(newPage) {
  return {
    type: CHANGE_ACTIVED_PAGE,
    newPage,
  }
}

export function showMessageBox(msgOK = null, msgNOK = null, showCopyButton = false) {
  return {
    type: SHOW_MESSAGE_BOX,
    msgOK,
    msgNOK,
    showCopyButton,
  }
}

export function showLoadingBox(message, title) {
  return {
    type: SHOW_LOADING_BOX,
    message,
    title,
  }
}

export function hideLoadingBox() {
  return {
    type: HIDE_LOADING_BOX,
  }
}

export function selectedTpChanged(tpId) {
  // tpId = 0 => significa Todos TPS
  return {
    type: SELECTED_TP_CHANGED,
    tpId,
  }
}
